import NotFound from "components/Error/NotFound";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import { useEffect } from "react";

export default function NotFoundPage() {
  const { setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("Not Found");
  }, [setPageTitle]);

  return (
    <AppPage>
      <NotFound />
    </AppPage>
  );
}
